var viewer_rtlignore_default = {
  "gallery_container": "DOi3U",
  "imageTitleContainer": "_9NF4P",
  "clickableItem": "DNPXi",
  "prerender": "i04Ov",
  "expandButton": "uN-gk",
  "itemContainer": "ellHC",
  "expandIcon": "GNTKm",
  "itemOverlay": "UZhG7",
  "imageTitle": "_7-KkP",
  "pointer": "QvzAj",
  "fadeIn": "eODq9",
  "changing_background": "oOg6W"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
